import { EMAIL_ACTION } from "../const";

export const postEmail = (payload: any) => {
    return {
        type: EMAIL_ACTION,
        payload: payload,
    };
};
